<div class="weekday-editor" [formGroup]="detailsFormGroup">
    <div>
        <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday"></sc-dictionary-label>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayMonday" name="weekdayMonday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.monday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayTuesday" name="weekdayTuesday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.tuesday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayWednesday" name="weekdayWednesday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.wednesday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayThursday" name="weekdayThursday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.thursday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdayFriday" name="weekdayFriday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.friday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdaySaturday" name="weekdaySaturday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.saturday"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="weekdaySunday" name="weekdaySunday">
            <sc-dictionary-label dictionaryKey="tmc-yard.widgets.filter-administration.details-editor.transport.weekday-editor.weekday.sunday"></sc-dictionary-label>
        </mat-checkbox>
    </div>

</div>
